// extracted by mini-css-extract-plugin
module.exports = {"iframe-dialog--body":"iframe-dialog--body__nadHP","iframe-dialog--iframe":"iframe-dialog--iframe__EWSuF"};